export default "__VITE_ASSET__CuYbdoI1__"